import type { MarketRepository } from '../../repositories/market/market.repository'
import type MarketTickerModel from '../../models/market-ticker.model'

export default class MarketController {
  constructor(private marketRepository: MarketRepository) {}

  async getSymbols(): Promise<string[]> {
    return this.marketRepository.getSymbols()
  }

  async getTickers(): Promise<MarketTickerModel[]> {
    return this.marketRepository.getTickers()
  }
}
